const commonRoutesPaths = {
    RESET_PASSWORD: 'reset-password',
    REGISTRATION: 'registration',
    REGISTRATION_STUDIO: 'registration-studio',
    REGISTRATION_USER: 'registration-user',
    LOGIN: 'login',
    EVENTS: 'events',
    WAITLIST_NOTIFICATION: 'waitlist-notification',
    ORGANISATION: 'organisation',
    USER: 'user',
    RESET_PASSWORD_CONFIRMATION: 'reset-password-confirmation',
    CLIENTS: 'clients',
    ICAL: 'ical',
};

const appUrl = 'app';

/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    commonRoutesPaths,
    appUrl,
};
